import { get } from "@ember/object";
import dayjs from "dayjs";
import { arrayIfNeeded } from "../xml-parsed-helpers";

/**
 * A JSON section extracted from a structured reimbursement DMP file.
 */

export default class AbstractDmpParser {
  getEntries(section) {
    return arrayIfNeeded(section.entry);
  }

  /**
   * This function transforms a string to a Date Object
   * The expected string to be transformed must be "YYYYMMDD"
   */
  transformStringToDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString, "YYYYMMDD").toDate();
    return new Date(date);
  }

  /**
   * Parses the date of procedure or encounter, using a default key path.
   * The key path can be overridden for specific use cases.
   */
  parseOccurredAt(object, keypath = "effectiveTime._attributes.value") {
    const effectiveTime = get(object, keypath);
    const parsedOccurredAt = dayjs.utc(effectiveTime, "YYYYMMDD");
    if (!parsedOccurredAt.isValid) {
      console.error(`Invalid date when parsing effectiveTime: ${effectiveTime}`);
      return null;
    }
    return parsedOccurredAt.toDate();
  }
}